export default class SingleResponse {
  /**
   * @param {*} data
   */
  constructor(data) {
    this.data = data;
  }
}
